import React from "react";
import PropTypes from "prop-types";
import moment from "moment/moment";
import {BookizonAppManager} from "../../../index";
import AppConfig from "../../../config/AppConfig";
import {ID_CATEGORIA_BELLEZZA_BENESSERE} from "../../../const/CategorieNegoziConstants";
import Countdown from "../../../components/Countdown";

export function DashboardBanner(props) {
    const today = moment().format('YYYY-MM-DD');
    const id_categoria = parseInt(props.negozio.id_categoria);

    if (id_categoria === ID_CATEGORIA_BELLEZZA_BENESSERE) {

        //Bookizon LIVE
        if ('2025-08-18' <= today && today <= '2025-08-25') {
            const handleClick = _ => BookizonAppManager.openInAppBrowser('https://bkzn.it/2b8nt?utm_source=app');
            return (
                <React.Fragment>
                    <div className={"bg-white shadow-sm rounded mb-3 overflow-hidden"}
                         onClick={handleClick}>
                        <img
                            src={`${AppConfig.webServerUrl}/app/Packages/AdminDashboard/Assets/app-banner-bookizon-live.png?v=8`}
                            className={"img-fluid"}/>
                    </div>
                </React.Fragment>
            )
        }


        //Bookizon lifestyle beauty
        if (today < '2025-09-15') {

            const allBackgorundColors = [
                ['rgba(147,25,87,1)','rgba(254,175,45,1)'],
                ['rgba(221,218,34,1)','rgba(181,178,10,1)'],
                ['rgba(232,4,5,1)','rgba(201,53,54,1)'],
                ['rgba(32,129,25,1)','rgba(56,225,45,1)'],
                ['rgba(183,56,113,1)','rgba(228,45,127,1)'],
            ];

            const bgColorIdx = moment().dayOfYear() % allBackgorundColors.length;
            const bgColors = allBackgorundColors[bgColorIdx];

            const wrapperStyle = {
                backgroundColor: `rgb(147, 25, 87)`,
                background: `linear-gradient(45deg, ${bgColors[0]} 0%, ${bgColors[1]} 100%)`
            }
            const handleClick = _ => BookizonAppManager.openInAppBrowser('https://bkzn.it/10gbj');
            return (
                <React.Fragment>
                    <div className={"shadow-sm rounded mb-3 overflow-hidden"} style={wrapperStyle}
                         onClick={handleClick}>

                        <div className={"p-3"}>
                            <Countdown target={{ year: 2025, month0: 8, day: 21, hour: 0, minute: 0, second: 0 }}/>
                        </div>

                        <img
                            src={`${AppConfig.webServerUrl}/app/Packages/AdminDashboard/Assets/banner-lifestyle-beauty-countdown-app.png`}
                            className={"img-fluid"}/>

                        {/* Countdown overlay */}
                    </div>
                </React.Fragment>
            )
        }
    }

    return '';
}

DashboardBanner.propTypes = {
    negozio: PropTypes.object
}
